/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_CustomerUserOverview_VestingSummaryDto } from '../models/Wealthlane_AwardService_Dtos_CustomerUserOverview_VestingSummaryDto';
import type { Wealthlane_AwardService_Dtos_UpcomingEvent_UpcomingEventDto } from '../models/Wealthlane_AwardService_Dtos_UpcomingEvent_UpcomingEventDto';
import type { Wealthlane_Shared_Hosting_Dtos_ParticipantsActivities_ParticipantsActivitiesDto } from '../models/Wealthlane_Shared_Hosting_Dtos_ParticipantsActivities_ParticipantsActivitiesDto';
import type { Wealthlane_Shared_Hosting_Dtos_TaskApproval_TaskApprovalDto } from '../models/Wealthlane_Shared_Hosting_Dtos_TaskApproval_TaskApprovalDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomerUserOverviewService {

    /**
     * @returns Wealthlane_Shared_Hosting_Dtos_ParticipantsActivities_ParticipantsActivitiesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCustomerUserOverviewParticipantsActivities(): CancelablePromise<Array<Wealthlane_Shared_Hosting_Dtos_ParticipantsActivities_ParticipantsActivitiesDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/customer-user-overview/participants-activities',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Shared_Hosting_Dtos_TaskApproval_TaskApprovalDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCustomerUserOverviewTaskApproval(): CancelablePromise<Array<Wealthlane_Shared_Hosting_Dtos_TaskApproval_TaskApprovalDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/customer-user-overview/task-approval',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_UpcomingEvent_UpcomingEventDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCustomerUserOverviewUpcomingEvents(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_UpcomingEvent_UpcomingEventDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/customer-user-overview/upcoming-events',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_CustomerUserOverview_VestingSummaryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCustomerUserOverviewVestingSummary(): CancelablePromise<Wealthlane_AwardService_Dtos_CustomerUserOverview_VestingSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/customer-user-overview/vesting-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
